import { createSlice } from "@reduxjs/toolkit";
import {
  getUsers,
  getMyProfile,
  addUser,
  updateUser,
  deleteUser,
  toggleUserBlock,
} from "./thunk";

const initialState = {
  users: [],
  selectedUser: null,
  loading: false,
  error: null,
  totalCount: 0,
  totalPages: 0,
  currentPage: 1,
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // ---------------- GET ALL ----------------
    builder
      .addCase(getUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload.data || [];
        state.totalCount = action.payload.responseDetails?.totalCount || 0;
        state.totalPages =
          action.payload.responseDetails?.pagination?.totalPages || 1;
        state.currentPage =
          action.payload.responseDetails?.pagination?.currentPage || 1;
      })
      .addCase(getUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "حدث خطأ أثناء تحميل المستخدمين";
      });

    // ---------------- GET MY PROFILE ----------------
    builder
      .addCase(getMyProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMyProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedUser = action.payload;
      })
      .addCase(getMyProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "حدث خطأ أثناء تحميل الملف الشخصي";
      });

    // ---------------- GET BY ID ----------------
    // builder
    //   .addCase(getUserById.pending, (state) => {
    //     state.loading = true;
    //   })
    //   .addCase(getUserById.fulfilled, (state, action) => {
    //     state.loading = false;
    //     state.selectedUser = action.payload;
    //   })
    //   .addCase(getUserById.rejected, (state, action) => {
    //     state.loading = false;
    //     state.error = action.payload || "حدث خطأ أثناء تحميل بيانات المستخدم";
    //   });

    // ---------------- ADD ----------------
    builder
      .addCase(addUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(addUser.fulfilled, (state, action) => {
        state.loading = false;
        state.users.unshift(action.payload);
      })
      .addCase(addUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "حدث خطأ أثناء إضافة المستخدم";
      });

    // ---------------- UPDATE ----------------
    builder
      .addCase(updateUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.loading = false;
        const updatedId = action.payload.id || action.payload._id;
        state.users = state.users.map((user) =>
          (user.id?.toString() || user._id?.toString()) ===
          updatedId?.toString()
            ? { ...user, ...action.payload }
            : user,
        );
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "حدث خطأ أثناء تحديث المستخدم";
      });

    // ---------------- DELETE ----------------
    builder
      .addCase(deleteUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.loading = false;
        state.users = state.users.filter(
          (user) => user.id.toString() !== action.payload.id.toString(),
        );
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "حدث خطأ أثناء حذف المستخدم";
      });

    builder.addCase(toggleUserBlock.fulfilled, (state, action) => {
      const id = action.payload;

      state.users = state.users.map((user) => {
        if ((user._id || user.id) === id) {
          return {
            ...user,
            isBlocked: !user.isBlocked,
          };
        }
        return user;
      });
    });
  },
});

export default usersSlice.reducer;
